import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'cm-avatar-carousel',
    templateUrl: 'avatar-carousel.component.html',
    styleUrls: ['avatar-carousel.component.css']
})
export class AvatarCarouselComponent implements OnInit, OnChanges {

    @Input() images: string[] = []
    currentIndex: number = 0
    
    constructor() { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.images) {
            this.images = this.images.filter(image => image)
        }
    }

    public goto(index: number): void {
        if (index >= 0 && index < this.images.length) {
            this.currentIndex = index
        }
    }

    public next(): void {
      this.currentIndex++;
      if (this.currentIndex >= this.images.length ) {
        this.currentIndex = 0;
      }
    }

    public previous(): void {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.images.length - 1;
      }
    }
}


// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/avatar-carousel/avatar-carousel.component.ts